import * as React from 'react';
import { connect } from 'react-redux';
import NavBar from './NavBar';
import Container from './Container';
import SideBar from './Sidebar/SideBar';
import NotificationHubLoader from './Notificaciones/NotificationHubLoader';
import { useIsMobile } from '../hooks/useIsMobile';
import MobileLayout from '../mobile/MobileLayout';

const FloatingChatSupport = React.lazy(() => import('./Usuarios/FloatingChatSupport'));

function Landing({ idSeller, user }) {
  const isMobile = useIsMobile();

  React.useEffect(() => {
    document.body.classList.toggle('mobile-app-shell', isMobile);
    return () => document.body.classList.remove('mobile-app-shell');
  }, [isMobile]);

  if (isMobile) {
    return (
      <div className="App mobile-app" id="main-wrapper">
        <MobileLayout>
          <Container />
        </MobileLayout>
        <NotificationHubLoader userId={user?.userId} />
      </div>
    );
  }

  return (
    <div className={`App${user?.impersonation?.isActive ? ' impersonating' : ''}`} id="main-wrapper">
      <NavBar idSeller={idSeller} user={user} />
      <SideBar />
      <Container />
      <React.Suspense fallback={null}>
        <FloatingChatSupport />
      </React.Suspense>
      <NotificationHubLoader userId={user?.userId} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  idSeller: state.general?.idSeller,
  user: state.general,
});

export default connect(mapStateToProps)(Landing);
